import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('fieldLabelsModule', [
      'getFieldLabel',
      'getFieldEnabledForPersonType',
    ]),
  },
  methods: {
    getEnabledColumnHeaderMultiField(fieldStrings, headerText, columnTitle, isSortable,
      columnField, columnWidth) {
      // check whether any field string is enabled
      const items = fieldStrings.filter((fs) => {
        const fieldLabelParts = fs.split(':');
        return this.getFieldEnabledForPersonType(fieldLabelParts[3], fieldLabelParts[2],
          fieldLabelParts[1]);
      });

      if (items && items.length > 0) {
        return this.getBasicColumnHeader(headerText,
          columnTitle, isSortable, columnField, columnWidth);
      }
      return null;
    },
    getEnabledColumnHeader(fieldString, columnTitle, isSortable, columnField, columnWidth) {
      // Sample field string PER:01:ASSIGN:SCHOOL_YEAR
      // Sample method call to check if field is enabled:
      //    getFieldEnabledForPersonType('SCHOOL_YEAR', 'ASSIGN', person.personType)
      const fieldLabelParts = fieldString.split(':');

      // check whether field is enabled
      if (this.getFieldEnabledForPersonType(fieldLabelParts[3], fieldLabelParts[2],
        fieldLabelParts[1])) {
        return this.getBasicColumnHeader(this.getFieldLabel(fieldString),
          columnTitle, isSortable, columnField, columnWidth);
      }
      return null;
    },
    getBasicColumnHeader(headerText, columnTitle, isSortable, columnField, columnWidth) {
      return {
        header: headerText,
        title: columnTitle,
        sortable: isSortable,
        field: columnField,
        style: {
          width: columnWidth,
        },
      };
    },
  },
};
